import React from 'react'
import Klima from './klima';
import KlimaDetails from './klimaDetails';

export default function  Klima_Furthur() {
  return (
    <>
      <Klima />
      <KlimaDetails />
    </>
  )
}
